export enum PromoCodeDiscountType {
    None = 0,
    PercentOff = 1,
    DollarOff = 2
}
